@if (query.page()) {
  <app-ref-list #list [page]="query.page()"
                [newRefs$]="newRefs$"
                emptyMessage=""
                [showToggle]="false"
                [expanded]="true"
                [expandInline]="true" />
} @else {
  <app-loading />
}
@if (store.view.ref()) {
  <app-comment-reply #reply
                     [to]="to()"
                     [tags]="replyTags()"
                     (save)="newRefs$.next($event)" />
}
